import axios from '../../helpers/axios-setup';

export const acceptGDPRPolicy = () => axios.put('/account/data-transfer-consent');
